export interface Authority {
    authority: string;
}

// This should be renamed once we start using the API entitlements only
export interface MWUser {
    // Added, because the MW returns this property, as well
    costCenterName: string;
    groupName: string;
    permissionCategoryName: string;
    username: string;
    // This is the only place where additionalRoles appears in the UI, so I did not carry it over to the API
    additionalRoles?: string[];
    /** @deprecated */
    roleName: UserRole;
}

// This should be removed once we start using the API entitlements only
export interface DDVMWEntitlements {
    entitlements: { [key: string]: Authority[] };
    user: MWUser;
}

// Combines the MW user with the API user role
// This should be removed once we start using the API entitlements only
export type User = Pick<MWUser, Exclude<keyof MWUser, keyof DDVAPIUserRole>> & DDVAPIUserRole

export enum ExternalUserRole {
    ClientAnalyst = 'DDV_ClientAnalyst',
    ClientLimited = 'DDV_ClientLimited',
    ClientBaseUser = 'DDV_ClientBaseUser',
    EmptyUserRole = '',
}

export enum InternalUserRole {
    SuperUser = 'DDV_SuperUser',
    PowerUser = 'DDV_PowerUser',
    Editor = 'DDV_Editor',
    BaseUser = 'DDV_HSBaseUser',
    EmptyUserRole = '',
}

export type UserRole = ExternalUserRole | InternalUserRole;

// This should be removed once we start using the API entitlements only
export interface DDVAPIUserRole {
    roleName: UserRole;
}

// Used for getting full entitlements from the API now, switch entirely to it, when removing MW
export interface Entitlements {
    entitlements: { [key: string]: Authority[] };
    user: MWUser;
}

export function emptyUser(): User {
    return {
        costCenterName: '',
        groupName: '',
        permissionCategoryName: '',
        username: '',
        roleName: InternalUserRole.EmptyUserRole,
    };
}

export enum UserGroup {
    HS_USERS = 'HS Users',
    CLIENT_USERS = 'Client Users',
    CLIENT_LIMITED_USERS = 'Client Limited Users',
}
